/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
import { h, Fragment } from '@stencil/core';

export class Icon {
  viewBox: string;
  svg: HTMLElement;

  constructor(viewBox, svg) {
    this.viewBox = viewBox || '0 0 20 20';
    this.svg = svg;
  }
}
const svgs = {
  hamburger: new Icon(
    '0 0 20 20',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
        <g id="Search-Grid-View-Desktop" transform="translate(-1192.000000, -291.000000)">
          <rect id="Rectangle" x="1192" y="291" width="20" height="4" />
          <rect id="Rectangle" x="1192" y="299" width="20" height="4" />
          <rect id="Rectangle" x="1192" y="307" width="20" height="4" />
        </g>
      </g>
    )
  ),
  gridview: new Icon(
    '0 0 20 20',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
        <g id="Desktop-HD-Copy-32" transform="translate(-1220.000000, -291.000000)">
          <rect id="Rectangle" x="1220" y="291" width="9" height="8" />
          <rect id="Rectangle" x="1231" y="291" width="9" height="8" />
          <rect id="Rectangle" x="1220" y="303" width="9" height="8" />
          <rect id="Rectangle" x="1231" y="303" width="9" height="8" />
        </g>
      </g>
    )
  ),
  search: new Icon(
    '0 0 14 14',
    (
      <path
        d="M13.7,12.6l-3.8-3.8c.7-.9,1.1-2.1,1.1-3.2C10.9,2.5,8.5,0,5.5,0c-1.5,0-2.8.6-3.9,1.6C.6,2.6,0,4,0,5.5c0,3,2.5,5.5,5.5,5.5,1.2,0,2.3-.4,3.2-1.1h0s3.8,3.8,3.8,3.8c.2.2.5.3.8.2s.5-.3.6-.6c0-.3,0-.6-.2-.8h0ZM5.5,9.9c-2.4,0-4.4-2-4.4-4.4,0-1.2.5-2.3,1.3-3.1.8-.8,1.9-1.3,3.1-1.3,2.4,0,4.4,2,4.4,4.4,0,1.2-.5,2.3-1.3,3.1-.8.8-1.9,1.3-3.1,1.3Z"
        fill-rule="evenodd"
        fill="currentColor"
        stroke="none"
      />
    )
  ),
  cancel: new Icon(
    '0 0 15 15',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="Desktop-HD-Copy-33" transform="translate(-1202.000000, -206.000000)" stroke="currentColor">
          <path d="M1202.5,206.5 L1216.5,220.5" id="Line-2" />
          <path d="M1216.5,206.5 L1202.5,220.5" id="Line-3" />
        </g>
      </g>
    )
  ),
  cancelCircle: new Icon(
    '0 0 20 20',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop-HD-Copy-39" transform="translate(-367.000000, -142.000000)">
          <rect fill="none" x="0" y="0" width="1440" height="2779" />
          <g id="close_filter" transform="translate(368.000000, 143.000000)" stroke="currentColor">
            <g id="Group-4">
              <circle id="Oval" cx="9" cy="9" r="9" />
              <path
                d="M5.09479512,4.72631413 L13.2843854,13.9189424"
                id="Line-6"
                stroke-linecap="round"
                transform="translate(9.094795, 9.596314) rotate(-3.302581) translate(-9.094795, -9.596314) "
              />
              <path
                d="M5.09479512,4.72631413 L13.2843854,13.9189424"
                id="Line-6"
                stroke-linecap="round"
                transform="translate(9.094795, 9.596314) scale(-1, 1) rotate(-3.302581) translate(-9.094795, -9.596314) "
              />
            </g>
          </g>
        </g>
      </g>
    )
  ),
  filter: new Icon(
    '0 0 15 14',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
        <g id="iPhone-SE-Copy-35" transform="translate(-207.000000, -88.000000)" fill="currentColor" fill-rule="nonzero">
          <g id="Group-5" transform="translate(192.000000, 80.000000)">
            <g id="Group" transform="translate(15.000000, 6.000000)">
              <g id="filter" transform="translate(0.000000, 2.000000)">
                <path
                  d="M14.9565967,0.263986497 C14.8815544,0.102808041 14.721347,0 14.5453795,0 L0.454644359,0 C0.278676863,0 0.118530076,0.102808041 0.0434271725,0.263986497 C-0.0316151149,0.425164953 -0.0080962074,0.615682062 0.103861066,0.753168636 L5.5205443,7.4055547 L5.5205443,13.5396655 C5.5205443,13.6989412 5.60183001,13.8468621 5.7354271,13.9308271 C5.80865092,13.9767991 5.8917551,14 5.97516236,14 C6.04408245,14 6.11324501,13.9841031 6.17701277,13.9521252 L9.2204079,12.4247353 C9.37503865,12.3471536 9.47287246,12.1876323 9.47311492,12.0128894 L9.47905527,7.40573884 L14.8960416,0.753107258 C15.0080595,0.615682062 15.031639,0.425103575 14.9565967,0.263986497 Z M8.67395699,6.94736842 C8.6069766,7.02961485 8.57024346,7.13291392 8.57012223,7.23958877 L8.56430312,11.7264999 L6.42984103,12.797729 L6.42984103,7.24020255 C6.42984103,7.13334356 6.39316851,7.02979899 6.32600627,6.94736842 L1.4186771,0.920607642 L13.5812862,0.920607642 L8.67395699,6.94736842 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    )
  ),
  show: new Icon(
    '0 0 20 20',
    (
      <g stroke="none" fill="currentColor">
        <path d="M10,17c-6.2,0-9.8-6.5-9.9-6.8C0,10.1,0,9.9,0.1,9.8C0.2,9.5,3.8,3,10,3s9.8,6.5,9.9,6.8c0.1,0.1,0.1,0.3,0,0.5 S16.2,17,10,17z M1.1,10c0.7,1.1,3.9,6,8.9,6s8.2-4.9,8.9-6C18.2,8.9,15,4,10,4S1.8,8.9,1.1,10z" />
        <path d="M10,14c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S12.2,14,10,14z M10,7c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3 S11.7,7,10,7z" />
      </g>
    )
  ),
  edit: new Icon(
    '0 0 20 20',
    (
      <g fill="currentColor" stroke="none">
        <path
          d="M18.3,3.8l-1.1-1.1c-0.9-0.9-2.6-0.9-3.5,0L3.6,12.8c-0.1,0.1-0.2,0.3-0.3,0.4L2,17.7c-0.1,0.4,0,0.8,0.3,1.1
	        C2.5,18.9,2.8,19,3.1,19c0.1,0,0.2,0,0.3,0l4.4-1.3c0.2-0.1,0.3-0.2,0.4-0.3L18.3,7.3C18.7,6.8,19,6.2,19,5.6S18.7,4.3,18.3,3.8z
	        M3.1,18C3.1,18,3.1,18,3.1,18C3,18,3,18,3,18c0,0,0-0.1,0-0.1l1.1-3.7l2.7,2.7L3.1,18z M7.8,16.4l-3.2-3.1l8.7-8.7l3.2,3.1
	        L7.8,16.4z M17.6,6.6L17.2,7L14,3.8l0.4-0.4c0.6-0.6,1.5-0.6,2.1,0l1,1.1c0.3,0.3,0.4,0.6,0.4,1C18,6,17.8,6.3,17.6,6.6z"
        />
      </g>
    )
  ),
  trash: new Icon(
    '0 0 20 20',
    (
      <g fill="currentColor" stroke="none">
        <polygon points="13,1.9 13,1 7.6,1 7.6,1.9 4.1,1.9 4.1,2.9 16.5,2.9 16.5,1.9 	" />
        <path
          d="M16.4,3.8c-0.1-0.1-0.3-0.2-0.4-0.2H4.5c-0.2,0-0.3,0.1-0.4,0.2C4,3.9,4,4,4,4.1l0.9,14.4
          c0,0.3,0.2,0.5,0.5,0.5h9.8c0.2,0,0.5-0.2,0.4-0.4l0.9-14.4C16.5,4,16.5,3.9,16.4,3.8z M14.7,18H5.8L5,4.6h10.5L14.7,18z"
        />
        <rect x="7.1" y="6.2" width="1" height="10.2" />
        <rect x="9.8" y="6.2" width="1" height="10.2" />
        <rect x="12.4" y="6.2" width="1" height="10.2" />
      </g>
    )
  ),
  downShortArrow: new Icon(
    '0 0 13 11',
    (
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="iPhone-SE-Copy-34" transform="translate(-283.000000, -73.000000)" fill="currentColor">
          <g id="Group-2" transform="translate(16.000000, 68.000000)">
            <polygon id="Triangle-Copy-3" transform="translate(273.500000, 10.500000) scale(1, -1) translate(-273.500000, -10.500000) " points="273.5 5 280 16 267 16" />
          </g>
        </g>
      </g>
    )
  ),
  longRightArrow: new Icon(
    '0 0 20 20',
    (
      <path fill="currentColor" stroke="none" d="M19.2,9.5l-4.7-4.7c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1l3.5,3.5H0.8v1.5h16.1l-3.5,3.5
        c-0.3,0.3-0.3,0.8,0,1.1s0.8,0.3,1.1,0l4.7-4.7C19.5,10.2,19.5,9.8,19.2,9.5z"></path>
    )
  ),
  leftChevron: new Icon(
    '0 0 23 41',
    (
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1137.000000, -453.000000)">
          <g transform="translate(1148.500000, 473.500000) scale(-1, 1) translate(-1148.500000, -473.500000) translate(1137.000000, 453.000000)" fill="currentColor" fill-rule="nonzero">
            <path
              d="M0.668253328,3.88469172 C0.0890269508,3.30695145 -0.134995122,2.46704721 0.0805740591,1.6813628 C0.29614324,0.895678402 0.918553587,0.283577994 1.71334914,0.0756338837 C2.50814469,-0.132310226 3.3545771,0.0954936202 3.93380345,0.673233917 L22.3312689,18.8942711 C23.2229104,19.782632 23.2229104,21.217368 22.3312689,22.1057289 L3.93380345,40.3267661 C3.3545771,40.9045064 2.50814469,41.1323102 1.71334913,40.9243661 C0.918553569,40.716422 0.296143216,40.1043216 0.0805740368,39.3186372 C-0.134995143,38.5329528 0.0890269389,37.6930485 0.668253328,37.1153083 L17.4329437,20.5113881 L0.668253328,3.88469172 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    )
  ),
  rightChevron: new Icon(
    '0 0 23 41',
    (
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1137.000000, -299.000000)">
          <g id="next-new-(same-width)" transform="translate(1137.000000, 299.000000)" fill="currentColor" fill-rule="nonzero">
            <path
              d="M0.668253328,3.88469172 C0.0890269508,3.30695145 -0.134995122,2.46704721 0.0805740591,1.6813628 C0.29614324,0.895678402 0.918553587,0.283577994 1.71334914,0.0756338837 C2.50814469,-0.132310226 3.3545771,0.0954936202 3.93380345,0.673233917 L22.3312689,18.8942711 C23.2229104,19.782632 23.2229104,21.217368 22.3312689,22.1057289 L3.93380345,40.3267661 C3.3545771,40.9045064 2.50814469,41.1323102 1.71334913,40.9243661 C0.918553569,40.716422 0.296143216,40.1043216 0.0805740368,39.3186372 C-0.134995143,38.5329528 0.0890269389,37.6930485 0.668253328,37.1153083 L17.4329437,20.5113881 L0.668253328,3.88469172 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    )
  ),
  downChevron: new Icon(
    "0 0 15 9",
    <path d="M1 1L7.5 7.5L14 1" stroke="currentColor"/>
  ),
  calendar: new Icon(
    '0 0 20 20',
    (
      <g>
        <rect x="0.5" y="2.5" width="19" height="17" rx="1.5" stroke="currentColor" stroke-linejoin="round" />
        <rect x="4.5" y="7.5" width="1" height="1" stroke="currentColor" />
        <rect x="4.5" y="11" width="1" height="1" stroke="currentColor" />
        <rect x="4.5" y="14.5" width="1" height="1" stroke="currentColor" />
        <rect x="9.5" y="7.5" width="1" height="1" stroke="currentColor" />
        <rect x="9.5" y="11" width="1" height="1" stroke="currentColor" />
        <rect x="9.5" y="14.5" width="1" height="1" stroke="currentColor" />
        <rect x="14.5" y="7.5" width="1" height="1" stroke="currentColor" />
        <rect x="14.5" y="11" width="1" height="1" stroke="currentColor" />
        <rect x="14.5" y="14.5" width="1" height="1" stroke="currentColor" />
        <path d="M5 0.5V4.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M15 0.5V4.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M10 0.5V4.5" stroke="currentColor" stroke-linecap="round" />
      </g>
    )
  ),
  articles: new Icon(
    '0 0 20 20',
    (
      <g>
        <rect width="20" height="20" />
        <path
          d="M0.5 19.4V0.6C0.5 0.544772 0.544771 0.5 0.6 0.5H19.4C19.4552 0.5 19.5 0.544771 19.5 0.6V19.4C19.5 19.4552 19.4552 19.5 19.4 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4Z"
          stroke="currentColor"
        />
        <path
          d="M17.5 6.4V2.6C17.5 2.54477 17.4552 2.5 17.4 2.5H10.6C10.5448 2.5 10.5 2.54477 10.5 2.6V6.4C10.5 6.45523 10.5448 6.5 10.6 6.5H17.4C17.4552 6.5 17.5 6.45523 17.5 6.4Z"
          stroke="currentColor"
        />
        <path d="M17.5 10.5H2.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M8.5 4.5H2.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M17.5 15.5H2.5" stroke="currentColor" stroke-linecap="round" />
      </g>
    )
  ),
  products: new Icon(
    '0 0 20 20',
    (
      <g>
        <path d="M4 8.5V15.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M10 12.5V19.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M16 8.5V15.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M4 8.5L10 12.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M10 4.5L16 8.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M4 15.5L10 19.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M0.5 15V18" stroke="currentColor" stroke-linecap="round" />
        <path d="M0.5 18L2.99615 19.6641" stroke="currentColor" stroke-linecap="round" />
        <path d="M19.5 15V18" stroke="currentColor" stroke-linecap="round" />
        <path d="M19.4962 18L17 19.6641" stroke="currentColor" stroke-linecap="round" />
        <path d="M12.4962 2.1641L10 0.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M9.99615 0.5L7.5 2.1641" stroke="currentColor" stroke-linecap="round" />
        <path d="M16 8.5L10 12.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M10 4.5L4 8.5" stroke="currentColor" stroke-linecap="round" />
        <path d="M16 15.5L10 19.5" stroke="currentColor" stroke-linecap="round" />
      </g>
    )
  ),
  projects: new Icon(
    '0 0 20 20',
    (
      <g id="icon / project / grey">
        <rect width="20" height="20" />
        <path
          id="Vector 6"
          d="M0.5 19.4V0.6C0.5 0.544772 0.544771 0.5 0.6 0.5H19.4C19.4552 0.5 19.5 0.544771 19.5 0.6V19.4C19.5 19.4552 19.4552 19.5 19.4 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4Z"
          stroke="currentColor"
        />
        <path id="Line 9" d="M6 17.5H11" stroke="currentColor" stroke-linecap="round" />
        <path id="Line 9_2" d="M8 15.5H11" stroke="currentColor" stroke-linecap="round" />
        <path
          id="Vector 5"
          d="M12.4 2.5H2.6C2.54477 2.5 2.5 2.54477 2.5 2.6V7.4C2.5 7.45523 2.54477 7.5 2.6 7.5H6.4C6.45523 7.5 6.5 7.54477 6.5 7.6V10.4C6.5 10.4552 6.45523 10.5 6.4 10.5H3.6C3.54477 10.5 3.5 10.5448 3.5 10.6V13.4C3.5 13.4552 3.54477 13.5 3.6 13.5H17.4C17.4552 13.5 17.5 13.4552 17.5 13.4V2.6C17.5 2.54477 17.4552 2.5 17.4 2.5H14.6C14.5448 2.5 14.5 2.54477 14.5 2.6V4.9C14.5 4.95523 14.4552 5 14.4 5H12.6C12.5448 5 12.5 4.95523 12.5 4.9V2.6C12.5 2.54477 12.4552 2.5 12.4 2.5Z"
          stroke="currentColor"
        />
        <path
          id="Vector 7"
          d="M13.5 17.4V15.6C13.5 15.5448 13.5448 15.5 13.6 15.5H17.4C17.4552 15.5 17.5 15.5448 17.5 15.6V17.4C17.5 17.4552 17.4552 17.5 17.4 17.5H13.6C13.5448 17.5 13.5 17.4552 13.5 17.4Z"
          stroke="currentColor"
        />
      </g>
    )
  ),
  folders: new Icon(
    '0 0 20 20',
    (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.1252 3C2.76081 3 2.46549 3.31034 2.46549 3.70654V5.09996H1.15388C0.792967 5.09996 0.5 5.41823 0.5 5.80003V16.3C0.5 16.6865 0.798414 17 1.15388 17H18.8461C19.207 17 19.5 16.6818 19.5 16.3V5.80003C19.5 5.41346 19.2015 5.09996 18.8461 5.09996L11.6379 5.0935V3.70654C11.6379 3.31657 11.343 3 10.9782 3H3.1252Z"
        stroke="currentColor"
      />
    )
  ),
  competitions: new Icon(
    '0 0 20 20',
    (
      <g>
        <path
          d="M10 0.5C6.54545 0.5 4 3.54545 4 7C4 10.4545 7 14 7 14V18.3636C7 18.9912 7.50877 19.5 8.13636 19.5H11.8636C12.4912 19.5 13 18.9912 13 18.3636V14C13 14 16 10.4545 16 7C16 3.54545 13.4545 0.5 10 0.5Z"
          stroke="currentColor"
          stroke-width="1.13636"
        />
        <path d="M7 14.5L13 14.5" stroke="currentColor" stroke-width="1.13636" />
        <path d="M7 17L13 17" stroke="currentColor" stroke-width="1.13636" />
      </g>
    )
  ),
  website: new Icon(
    '0 0 30 30',
    (
      <g>
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb" fill-rule="evenodd"></path>
        <path
          class="social-fill"
          d="M15 5a10 10 0 1010 10A10 10 0 0015 5zm8 9.5h-3a13.84 13.84 0 00-1.77-6.82A8 8 0 0123 14.5zm-6.5 8.35a6.71 6.71 0 01-.9.12V15.5H19c-.11 3.28-1.12 6.13-2.5 7.35zM11 15.5h3.6V23a8.06 8.06 0 01-1.1-.13c-1.38-1.24-2.39-4.09-2.5-7.37zm2.5-8.35A8.06 8.06 0 0114.6 7v7.5H11c.11-3.28 1.12-6.13 2.5-7.35zm2.1 7.35V7a6.71 6.71 0 01.9.12c1.38 1.22 2.39 4.07 2.49 7.35zm-3.82-6.82A13.84 13.84 0 0010 14.5H7a8 8 0 014.78-6.82zM7 15.5h3a13.84 13.84 0 001.77 6.82A8 8 0 017 15.5zm11.19 6.82A13.84 13.84 0 0020 15.5h3a8 8 0 01-4.78 6.82z"
          fill="#303030"
        ></path>
      </g>
    )
  ),
  email: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M5.14 9.73a3 3 0 00-.14.9v8.74a3 3 0 003 3h14a3 3 0 003-3v-8.74a3 3 0 00-.14-.9L15 16.48zM6 8.4l9 6.17 9-6.17a3 3 0 00-2-.77H8a3 3 0 00-2 .77z"
          fill="#303030"
        ></path>
      </g>
    )
  ),
  facebook: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M19.8 15.88l.46-3.56h-3.52v-2.27c0-1 .29-1.73 1.76-1.73h1.89V5.14A26.37 26.37 0 0017.64 5c-2.71 0-4.57 1.66-4.57 4.7v2.62H10v3.56h3.07V25h3.67v-9.12z"
          fill="#2f302f"
        ></path>
      </g>
    )
  ),
  facebook_f: new Icon(
    "0 0 8 13",
    <path d="M4.87597 12.5V7.03933H6.69619L6.96585 4.88202H4.87597V3.53371C4.87597 2.92697 5.07821 2.52247 5.95462 2.52247H7.10069V0.567416C6.89844 0.567416 6.22428 0.5 5.48271 0.5C3.86473 0.5 2.71866 1.51124 2.71866 3.33146V4.88202H0.898438V7.03933H2.71866V12.5H4.87597Z"
      stroke="none"
      fill="currentColor"
    />
  ),
  instagram: new Icon(
    '0 0 30 30',
    (
      <g>
        <defs>
          <linearGradient id="brand-gradient">
            <stop stop-color="#E09B3D"/>
            <stop offset="0.3" stop-color="#C74C4D"/>
            <stop offset="0.6" stop-color="#C21975"/>
            <stop offset="1" stop-color="#7024C4"/>
          </linearGradient>
        </defs>
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill-rule="evenodd" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M11.35 6h7.27A5.36 5.36 0 0124 11.35v7.27A5.36 5.36 0 0118.62 24h-7.27A5.36 5.36 0 016 18.62v-7.27A5.36 5.36 0 0111.35 6zm7.27 16.16a3.55 3.55 0 003.54-3.54v-7.27a3.54 3.54 0 00-3.54-3.54h-7.27a3.53 3.53 0 00-3.54 3.54v7.27a3.54 3.54 0 003.54 3.54z"></path>
        <path class="social-fill" d="M10.34 15A4.65 4.65 0 1115 19.63 4.64 4.64 0 0110.34 15zm1.8 0A2.84 2.84 0 1015 12.14 2.84 2.84 0 0012.14 15z"></path>
        <path class="social-fill" d="M19.64 11.49a1.12 1.12 0 10-1.11-1.12 1.11 1.11 0 001.11 1.12z" fill="#303030"></path>
      </g>
    )
  ),
  twitter: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M25 8.89a8.16 8.16 0 01-2.36.64 4.08 4.08 0 001.81-2.23 8.54 8.54 0 01-2.61 1 4.12 4.12 0 00-7.1 2.7 4 4 0 00.11.92 11.75 11.75 0 01-8.46-4.18 4 4 0 001.27 5.39 4.19 4.19 0 01-1.86-.5 4.07 4.07 0 003.29 4 4.2 4.2 0 01-1.09.15 3.94 3.94 0 01-.77-.07 4.1 4.1 0 003.83 2.8A8.25 8.25 0 016 21.24H5A11.8 11.8 0 0011.29 23 11.49 11.49 0 0023 11.51v-.53a8.15 8.15 0 002-2.09z"
          fill="#2f302f"
        ></path>
      </g>
    )
  ),
  twitter_x: new Icon(
    "0 0 12 13",
    (<path d="M7.1,5.6l4.3-5.1h-1L6.7,4.9l-3-4.4H0.2l4.6,6.7l-4.6,5.3h1l4-4.7l3.2,4.7h3.5L7.1,5.6L7.1,5.6L7.1,5.6z M5.7,7.2L5.2,6.6L1.6,1.3h1.6l3,4.3l0.5,0.7l3.8,5.5H8.8L5.7,7.2L5.7,7.2L5.7,7.2z"
      stroke="none"
      fill="currentColor"
    />)
  ),
  pinterest: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M15 6a9 9 0 00-3.61 17.24 7.68 7.68 0 01.15-2.06c.18-.73 1.16-4.91 1.16-4.91a3.4 3.4 0 01-.29-1.42c0-1.33.78-2.33 1.74-2.33a1.2 1.2 0 011.21 1.35 19.34 19.34 0 01-.79 3.19A1.39 1.39 0 0016 18.8c1.7 0 2.85-2.19 2.85-4.79 0-2-1.33-3.45-3.74-3.45a4.26 4.26 0 00-4.43 4.31 2.61 2.61 0 00.59 1.77.43.43 0 01.13.5l-.18.72a.31.31 0 01-.45.23 3.47 3.47 0 01-1.85-3.44C8.91 12.09 11.07 9 15.35 9A5.37 5.37 0 0121 14.18c0 3.53-2 6.17-4.85 6.17A2.56 2.56 0 0114 19.23s-.52 2.07-.63 2.47a7.82 7.82 0 01-.91 1.93A9 9 0 1015 6z"
          fill="#2f302f"
        ></path>
      </g>
    )
  ),
  linkedin: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M24 21.79h-3.43v-5.52c0-1.38-.5-2.33-1.74-2.33a1.89 1.89 0 00-1.76 1.26 2.32 2.32 0 00-.07.8v5.76h-3.47V11.45H17v1.46a3.4 3.4 0 013.09-1.71c2.26 0 3.95 1.48 3.95 4.65zM9.92 10.07a1.79 1.79 0 110-3.57 1.79 1.79 0 110 3.57zM8.2 11.48h3.43v10.31H8.2z"
          fill="#2f302f"
        ></path>
      </g>
    )
  ),
  youtube: new Icon(
    '0 0 30 30',
    (
      <g fill-rule="evenodd">
        <path d="M15 30A15 15 0 100 15a15 15 0 0015 15z" fill="#ebebeb"></path>
        <path
          class="social-fill"
          d="M12.93 17.59V12l5.41 2.82zM24.8 11a4.26 4.26 0 00-.8-2 2.87 2.87 0 00-2-.84C19.2 8 15 8 15 8s-4.19 0-7 .2A2.87 2.87 0 006 9a4.26 4.26 0 00-.8 2 30.31 30.31 0 00-.2 3.24v1.52A30.24 30.24 0 005.2 19a4.26 4.26 0 00.8 2 3.38 3.38 0 002.2.86C9.8 22 15 22 15 22s4.2 0 7-.21a2.78 2.78 0 002-.79 4.26 4.26 0 00.8-2 30.24 30.24 0 00.2-3.23v-1.53a30.31 30.31 0 00-.2-3.24z"
          fill="#2f302f"
        ></path>
      </g>
    )
  ),
  checkCircle: new Icon(
    '0 0 500 500',
    (
      <g fill="currentColor">
        <path d="M250 496.05C114.33 496.05 3.95 385.67 3.95 250 3.95 114.33 114.33 3.95 250 3.95c135.67 0 246.05 110.38 246.05 246.05 0 135.67-110.38 246.05-246.05 246.05zm0-457.76C133.26 38.29 38.29 133.26 38.29 250c0 116.74 94.98 211.71 211.71 211.71 116.74 0 211.71-94.97 211.71-211.71 0-116.74-94.97-211.71-211.71-211.71z"></path>
        <path d="M366.18 192.33c6.07-7.28 5.08-18.11-2.2-24.18s-18.11-5.09-24.18 2.2L237.4 293.23l-55.37-55.37c-6.7-6.7-17.57-6.7-24.28 0-6.7 6.7-6.7 17.57 0 24.28l68.66 68.66c.19.19.39.35.59.53.19.17.37.35.56.52.02.02.05.04.07.06.17.14.36.27.53.41.26.19.51.39.77.57.2.14.41.26.61.39.26.16.51.31.78.46.21.11.42.22.63.32.28.14.55.27.84.39.2.09.41.17.61.25.3.12.6.22.91.32l.58.18c.33.09.66.17.99.24l.54.12c.37.07.74.12 1.11.16l.44.06c.52.05 1.04.07 1.56.07.59 0 1.17-.03 1.75-.09.16-.02.33-.05.49-.07.42-.06.84-.12 1.25-.2.2-.04.39-.1.59-.14.37-.09.75-.19 1.11-.31.21-.07.42-.15.64-.22a14.331 14.331 0 0 0 1.68-.71c.31-.15.62-.31.92-.49.23-.13.45-.26.67-.4.28-.18.56-.37.84-.57.22-.16.45-.32.66-.49.27-.21.52-.44.78-.67.2-.18.41-.35.6-.55.05-.05.1-.09.15-.14.26-.26.48-.53.72-.79.11-.12.23-.23.33-.36l.13-.15.01-.01 114.33-137.16z"></path>
      </g>
    )
  ),
  crossCircle: new Icon(
    '0 0 500 500',
    (
      <g fill="currentColor">
        <path d="M250 496C114.3 496 4 385.7 4 250S114.3 4 250 4s246 110.3 246 246-110.3 246-246 246zm0-457.7c-116.7 0-211.7 95-211.7 211.7s95 211.7 211.7 211.7c116.7 0 211.7-95 211.7-211.7 0-116.7-95-211.7-211.7-211.7z"></path>
        <path d="M275.5 250l76.3-76.3c7-7 7-18.4 0-25.5-7-7-18.4-7-25.5 0L250 224.5l-76.3-76.3c-7-7-18.4-7-25.5 0-7 7-7 18.4 0 25.5l76.3 76.3-76.3 76.3c-7 7-7 18.4 0 25.5 3.5 3.5 8.1 5.3 12.7 5.3s9.2-1.8 12.7-5.3l76.3-76.3 76.3 76.3c3.5 3.5 8.1 5.3 12.7 5.3s9.2-1.8 12.7-5.3c7-7 7-18.4 0-25.5L275.5 250zM720 384l178 178m-178 0l178-178"></path>
      </g>
    )
  ),
  warningCircle: new Icon(
    '0 0 21.5 21.5',
    (
      <g fill="currentColor">
        <path
          stroke="transparent"
          d="M10.8 21.5C4.8 21.5 0 16.7 0 10.8S4.8 0 10.8 0s10.8 4.8 10.8 10.8-4.9 10.7-10.8 10.7zm0-20c-5.1 0-9.2 4.1-9.2 9.2s4 9.3 9.2 9.3 9.2-4.1 9.2-9.2-4.1-9.3-9.2-9.3z"
        ></path>
        <path stroke="transparent" d="M10.8 13c-.4 0-.8-.3-.8-.8v-6c0-.4.3-.8.8-.8s.8.3.8.8v6c-.1.5-.4.8-.8.8zm0 .8c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"></path>
      </g>
    )
  ),
  externalLink: new Icon(
    '0 0 25 24',
    (
      <Fragment>
        <path
          d="M18.5,12.2c-0.4,0-0.8,0.3-0.8,0.8v6c0,0.3-0.1,0.7-0.4,0.9s-0.6,0.4-0.9,0.4h-11c-0.3,0-0.7-0.1-0.9-0.4
          S4.2,19.3,4.2,19V8c0-0.3,0.1-0.7,0.4-0.9s0.6-0.4,0.9-0.4h6c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-6c-0.7,0-1.4,0.3-1.9,0.8
          S2.8,7.3,2.8,8v11c0,0.7,0.3,1.4,0.8,1.9s1.2,0.8,1.9,0.8h11c0.7,0,1.4-0.3,1.9-0.8s0.8-1.2,0.8-1.9v-6
          C19.2,12.6,18.9,12.2,18.5,12.2z"
          fill="currentColor" stroke="transparent"
        />
        <path
          d="M22.2,2.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1,0-0.2-0.1-0.3-0.1h-6c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h4.2
          L10,13.5c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2l9.7-9.7V9c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V3
          C22.2,2.9,22.2,2.8,22.2,2.7z"
          fill="currentColor" stroke="transparent"
        />
      </Fragment>
    )
  ),
  externalLink2: new Icon("0 0 24 24",
    (<Fragment>
      <path d="M17 13.5V21H3V6H9.5" stroke="currentColor" fill="none" stroke-linecap="square"/>
      <path d="M19.9167 8.66667V3H14.25" stroke="currentColor" fill="none" stroke-linecap="square"/>
      <path d="M19.9163 3L19.208 3.70833" stroke="currentColor" fill="none" stroke-linecap="round"/>
      <path d="M19.2083 3.70801L10 12.9163" stroke="currentColor" fill="none" stroke-linecap="square"/>
    </Fragment>)
  ),
  download: new Icon(
    '0 0 20 20',
    (
      <g fill="currentColor" stroke="transparent">
        <path d="M17.5,11.9c-0.3,0-0.6,0.3-0.6,0.6v3.3c0,0.3-0.1,0.5-0.3,0.7s-0.5,0.3-0.7,0.3H4.2c-0.3,0-0.5-0.1-0.7-0.3
          c-0.2-0.2-0.3-0.5-0.3-0.7v-3.3c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v3.3c0,0.6,0.2,1.2,0.7,1.6c0.4,0.4,1,0.7,1.6,0.7h11.7
          c0.6,0,1.2-0.2,1.6-0.7s0.7-1,0.7-1.6v-3.3C18.1,12.2,17.8,11.9,17.5,11.9z" />
        <path d="M9.6,12.9C9.6,13,9.7,13,9.8,13.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0.1,0,0.2,0,0.2,0
          c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0l4.2-4.2c0.2-0.2,0.2-0.6,0-0.9s-0.6-0.2-0.9,0L10.6,11V2.5c0-0.3-0.3-0.6-0.6-0.6
          S9.4,2.2,9.4,2.5V11L6.3,7.9C6,7.6,5.6,7.6,5.4,7.9s-0.2,0.6,0,0.9L9.6,12.9z" />
      </g>      
    )
  ),
  upload: new Icon("0 0 25 24", (
    <Fragment>
      <path d="M12.5 4V17" stroke="currentColor" stroke-linecap="square" />
      <path d="M7.5 8L12.5 3L17.5 8" stroke="currentColor" fill="none" stroke-linecap="square" />
      <path d="M20.5 21H4.5" stroke="currentColor" stroke-linecap="square" />
    </Fragment>
  )),
  rewind_10: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M13 3.05493V5.5L9 2.75L13 0V2.04938C18.0533 2.5511 22 6.81465 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23871 3.11984 6.73803 4.92893 4.92893L5.63604 5.63604C4.00681 7.26527 3 9.51458 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.36745 17.5 3.55237 13 3.05493Z"
        fill="currentColor"
        stroke="none" />
      <path fill-rule="evenodd" clip-rule="evenodd" 
        d="M11.582 12.377C11.582 14.5308 12.4951 15.9058 14.1655 15.9058C15.8467 15.9058 16.7437 14.52 16.7437 12.377V11.8076C16.7437 9.64307 15.8413 8.2627 14.1709 8.2627C12.5005 8.2627 11.582 9.64844 11.582 11.8076V12.377ZM12.5112 11.813C12.5112 10.0781 13.1396 9.08447 14.1655 9.08447C15.186 9.08447 15.8145 10.0781 15.8145 11.813V12.3662C15.8145 14.1011 15.186 15.084 14.1655 15.084C13.1396 15.084 12.5112 14.1011 12.5112 12.3662V11.813Z"
        fill="currentColor"
        stroke="none" />
      <path d="M10.0029 15.75V8.41846H9.13281C8.56348 8.72461 7.88135 9.12744 7.32812 9.5249V10.481C7.84375 10.1265 8.66016 9.62695 9.05762 9.41211H9.07373V15.75H10.0029Z"
        fill="currentColor"
        stroke="none" />
   </Fragment>
  )),
  rewind_5: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M13 3.05493V5.5L9 2.75L13 0V2.04938C18.0533 2.5511 22 6.81465 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23871 3.11984 6.73803 4.92893 4.92893L5.63604 5.63604C4.00681 7.26527 3 9.51458 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.36745 17.5 3.55237 13 3.05493Z" fill="currentColor"/>
      <path d="M9.54688 13.9082C9.62207 14.9717 10.4492 15.9062 11.9639 15.9062C13.457 15.9062 14.6011 14.8696 14.6011 13.3604C14.6011 11.8887 13.4946 10.9004 12.1787 10.9004C11.3945 10.9004 10.7822 11.2764 10.5996 11.5288H10.5835L10.8252 9.22998H14.0532V8.4082H10.0356L9.63281 12.6729H10.4277C10.6426 12.1948 11.1313 11.6953 12.0391 11.6953C12.9253 11.6953 13.6558 12.3398 13.6558 13.3872C13.6558 14.5044 12.7749 15.0952 12.0229 15.0952C11.1797 15.0952 10.5674 14.6816 10.4492 13.9082H9.54688Z" fill="currentColor"/>
    </Fragment>
  )),
  rewind_15: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M13 3.05493V5.5L9 2.75L13 0V2.04938C18.0533 2.5511 22 6.81465 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23871 3.11984 6.73803 4.92893 4.92893L5.63604 5.63604C4.00681 7.26527 3 9.51458 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.36745 17.5 3.55237 13 3.05493Z"
        fill="currentColor"
        stroke="none" />
      <path d="M11.7109 13.9082C11.7861 14.9717 12.6133 15.9062 14.1279 15.9062C15.6211 15.9062 16.7651 14.8696 16.7651 13.3604C16.7651 11.8887 15.6587 10.9004 14.3428 10.9004C13.5586 10.9004 12.9463 11.2764 12.7637 11.5288H12.7476L12.9893 9.22998H16.2173V8.4082H12.1997L11.7969 12.6729H12.5918C12.8066 12.1948 13.2954 11.6953 14.2031 11.6953C15.0894 11.6953 15.8198 12.3398 15.8198 13.3872C15.8198 14.5044 14.939 15.0952 14.187 15.0952C13.3438 15.0952 12.7314 14.6816 12.6133 13.9082H11.7109Z"
        fill="currentColor"
        stroke="none" />
      <path d="M9.91699 15.7505V8.41895H9.04688C8.47754 8.7251 7.79541 9.12793 7.24219 9.52539V10.4814C7.75781 10.127 8.57422 9.62744 8.97168 9.4126H8.98779V15.7505H9.91699Z"
        fill="currentColor"
        stroke="none"/>
    </Fragment>
  )),
  fast_forward10: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M10.002 15.75V8.41846H9.13184C8.5625 8.72461 7.88037 9.12744 7.32715 9.5249V10.481C7.84277 10.1265 8.65918 9.62695 9.05664 9.41211H9.07275V15.75H10.002Z" fill="currentColor"/>
      <path d="M11.5811 12.377C11.5811 14.5308 12.4941 15.9058 14.1646 15.9058C15.8457 15.9058 16.7427 14.52 16.7427 12.377V11.8076C16.7427 9.64307 15.8403 8.2627 14.1699 8.2627C12.4995 8.2627 11.5811 9.64844 11.5811 11.8076V12.377ZM12.5103 11.813C12.5103 10.0781 13.1387 9.08447 14.1646 9.08447C15.1851 9.08447 15.8135 10.0781 15.8135 11.813V12.3662C15.8135 14.1011 15.1851 15.084 14.1646 15.084C13.1387 15.084 12.5103 14.1011 12.5103 12.3662V11.813Z" fill="currentColor"/>
      <path d="M11 3.05493V5.5L15 2.75L11 0V2.04938C5.94668 2.5511 2 6.81465 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.23871 20.8802 6.73803 19.0711 4.92893L18.364 5.63604C19.9932 7.26527 21 9.51458 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.36745 6.50005 3.55237 11 3.05493Z" fill="currentColor"/>
    </Fragment>
  )),
  fast_forward15: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M9.91602 15.75V8.41846H9.0459C8.47656 8.72461 7.79443 9.12744 7.24121 9.5249V10.481C7.75684 10.1265 8.57324 9.62695 8.9707 9.41211H8.98682V15.75H9.91602Z"
        fill="currentColor"
        stroke="none" />
      <path d="M11.71 13.9077C11.7852 14.9712 12.6123 15.9058 14.127 15.9058C15.6201 15.9058 16.7642 14.8691 16.7642 13.3599C16.7642 11.8882 15.6577 10.8999 14.3418 10.8999C13.5576 10.8999 12.9453 11.2759 12.7627 11.5283H12.7466L12.9883 9.22949H16.2163V8.40771H12.1987L11.7959 12.6724H12.5908C12.8057 12.1943 13.2944 11.6948 14.2021 11.6948C15.0884 11.6948 15.8188 12.3394 15.8188 13.3867C15.8188 14.5039 14.938 15.0947 14.186 15.0947C13.3428 15.0947 12.7305 14.6812 12.6123 13.9077H11.71Z"
        fill="currentColor"
        stroke="none" />
      <path d="M11 3.05493V5.5L15 2.75L11 0V2.04938C5.94668 2.5511 2 6.81465 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.23871 20.8802 6.73803 19.0711 4.92893L18.364 5.63604C19.9932 7.26527 21 9.51458 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.36745 6.50005 3.55237 11 3.05493Z"
        fill="currentColor"
        stroke="none" />
    </Fragment>
  )),
  voice: new Icon("0 0 34 34", (
    <Fragment>
      <line class="voice-1" stroke="currentColor" fill="none" stroke-linecap="square" x1="10.6" y1="5" x2="10.6" y2="29"/>
      <line class="voice-2" stroke="currentColor" fill="none" stroke-linecap="square" x1="17" y1="10.6" x2="17" y2="23.4"/>
      <line class="voice-3" stroke="currentColor" fill="none" stroke-linecap="square" x1="23.4" y1="7.8" x2="23.4" y2="26.2"/>
      <line class="voice-4" stroke="currentColor" fill="none" stroke-linecap="square" x1="29" y1="13.5" x2="29" y2="20.5"/>
      <line class="voice-5" stroke="currentColor" fill="none" stroke-linecap="square" x1="5" y1="13.5" x2="5" y2="20.5"/>
    </Fragment>
  )),
  play_circle: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M10 15.75V8.25L15.5 12L10 15.75Z" fill="currentColor" stroke="none" />
      <path fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="currentColor"
        stroke="none" />
   </Fragment>
  )),
  pause: new Icon("0 0 24 24", (
    <Fragment>
     <path d="M4.5 3.5H9.5V20.5H4.5V3.5Z" stroke="currentColor"/>
      <path d="M14.5 3.5H19.5V20.5H14.5V3.5Z" stroke="currentColor"/>
    </Fragment>
  )),
  album_cover: new Icon("0 0 24 24", (
    <Fragment>
     <path d="M3.5 5.5V18.5M7.5 4.5V19.5M11.5 3.5V20.5L20.5 18.5V5.5L11.5 3.5Z" stroke="currentColor" stroke-linecap="square"
      vector-effect="non-scaling-stroke" />
   </Fragment>
  )),
  map_pin_flat: new Icon("0 0 24 24", (
    <g>
     <path d="M11.5 6.5H7.5M20.5 11.5V20.5H5C3.61929 20.5 2.5 19.3807 2.5 18M5 15.5H7M5 15.5C3.61929 15.5 2.5 16.6193 2.5 18M5 15.5H7.5V3.5H5C3.61929 3.5 2.5 4.61929 2.5 6V18M20.5 6.92857C20.5 9.78571 17 11.5 17 11.5C17 11.5 13.5 9.78571 13.5 6.92857C13.5 5.03502 15.067 3.5 17 3.5C18.933 3.5 20.5 5.03502 20.5 6.92857Z"
      stroke="currentColor" stroke-linecap="square"/>
   </g>
  )),
  archive_folder: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M20.5 20.5V8.5H3.5V20.5H20.5Z" stroke="currentColor" stroke-linecap="square"/>
      <path d="M6 8.5V2.5H10.5L12.5 4.5H18V8.5" stroke="currentColor" stroke-linecap="square"/>
      <path d="M7.5 12.5L11.5 12.5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"/>
   </Fragment>
  )),
  page_text_add: new Icon("0 0 24 24", (
    <path d="M12.5 21.5H4.5V2.5H19.5V12.5M18.5 15.5V18.5M18.5 18.5V21.5M18.5 18.5H15.5M18.5 18.5H21.5M8.5 6.5H15.5M8.5 10.5H11.5" stroke="currentColor" stroke-linecap="square"/>
  )),
  diamond: new Icon("0 0 24 24", (
    <path d="M7 8L5 10L7 12M1 10L7.5 3.5H16.5L23 10L12 21L1 10Z" stroke="currentColor" stroke-linecap="square"/>
  )),
  timeline: new Icon("0 0 24 24", (
    <path d="M3.5 9.5V3.5H20.5V9.5M3.5 9.5V20.5H20.5V9.5M3.5 9.5H20.5M9.5 6.5H17.5M7 6.5C7 6.77614 6.77614 7 6.5 7C6.22386 7 6 6.77614 6 6.5C6 6.22386 6.22386 6 6.5 6C6.77614 6 7 6.22386 7 6.5Z" stroke="currentColor" stroke-linecap="square"/>
  )),
  people_copy: new Icon("0 0 24 24", (
   <path d="M17.5 6.5V2.5H2.5V17.5H6.5M17.5 6.5H6.5V17.5M17.5 6.5H21.5V21.5H19.6432H8.35682H6.5V17.5M8.41683 21.2722C9.19178 18.5001 11.3986 16.5 14 16.5C16.6014 16.5 18.8082 18.5001 19.5832 21.2722M16.5 12C16.5 13.3807 15.3807 14.5 14 14.5C12.6193 14.5 11.5 13.3807 11.5 12C11.5 10.6193 12.6193 9.5 14 9.5C15.3807 9.5 16.5 10.6193 16.5 12Z" stroke="currentColor"/>
  )),
  bookmarks: new Icon("0 0 24 24", (
    <path d="M19.5 21.5V2.5H4.5V21.5L12 17.5L19.5 21.5Z" stroke="currentColor" stroke-linecap="round"/>
  )),
  file_folders: new Icon("0 0 24 24", (
    <path d="M17.5 16.5H21.5V5.5H14L12 3.5H6.5V7.5M2.5 20.5V7.5H8L10 9.5H17.5V20.5H2.5Z" stroke="currentColor" stroke-linecap="round"/>
  )),
  settings: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M9.15 5.35L6.0625 4.6375L4.6375 6.0625L5.35 9.15L2.5 11.05V12.95L5.35 14.85L4.6375 17.9375L6.0625 19.3625L9.15 18.65L11.05 21.5H12.95L14.85 18.65L17.9375 19.3625L19.3625 17.9375L18.65 14.85L21.5 12.95V11.05L18.65 9.15L19.3625 6.0625L17.9375 4.6375L14.85 5.35L12.95 2.5H11.05L9.15 5.35Z" stroke="currentColor"/>
      <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor"/>
    </Fragment>
  )), 
  archive: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M20.5 20.5V8.5H3.5V20.5H20.5Z" stroke="currentColor" stroke-linecap="square" />
      <path d="M6 8.5V2.5H10.5L12.5 4.5H18V8.5" stroke="currentColor" stroke-linecap="square"/>
      <path d="M7.5 12.5L11.5 12.5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" />
    </Fragment>
  )),
  search_2: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M14.4121 14.4121L20 20" stroke="currentColor" stroke-linecap="square"/>
      <path d="M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16Z" stroke="currentColor" stroke-linecap="square"/>
    </Fragment>
  )),
  sort: new Icon("0 0 20 20", (
    <Fragment>
      <path fill="currentColor" stroke="none" d="M17,4H4v1h13v-1Z"/>
      <path fill="currentColor" stroke="none" d="M13,9H4v1h9v-1Z"/>
      <path fill="currentColor" stroke="none" d="M10,14h-6v1h6v-1Z"/>
    </Fragment>
  )),
  checkmark_1_small: new Icon("0 0 32 32", (
    <path d="M10 17.5L14.5 22L22 10" stroke="currentColor" stroke-linecap="square"/>
  )),
  broken_chain_link_1: new Icon("0 0 24 24", (
    <path d="M8 3.5V4H9V3.5H8ZM9 1.5V1H8V1.5H9ZM16 20.5V20H15V20.5H16ZM15 22.5V23H16V22.5H15ZM3.5 9H4V8H3.5V9ZM1.5 8H1V9H1.5V8ZM20.5 15H20V16H20.5V15ZM22.5 16H23V15H22.5V16ZM4.64645 5.35355L5 5.70711L5.70711 5L5.35355 4.64645L4.64645 5.35355ZM3.35355 2.64645L3 2.29289L2.29289 3L2.64645 3.35355L3.35355 2.64645ZM19.3536 18.6464L19 18.2929L18.2929 19L18.6464 19.3536L19.3536 18.6464ZM20.6464 21.3536L21 21.7071L21.7071 21L21.3536 20.6464L20.6464 21.3536ZM2.5 14.5L2.14645 14.1464L1.79289 14.5L2.14645 14.8536L2.5 14.5ZM9.5 21.5L9.14645 21.8536L9.5 22.2071L9.85355 21.8536L9.5 21.5ZM21.5 9.5L21.8536 9.85355L22.2071 9.5L21.8536 9.14645L21.5 9.5ZM14.5 2.5L14.8536 2.14645L14.5 1.79289L14.1464 2.14645L14.5 2.5ZM10.1464 6.14645L9.79289 6.5L10.5 7.20711L10.8536 6.85355L10.1464 6.14645ZM6.85355 10.8536L7.20711 10.5L6.5 9.79289L6.14645 10.1464L6.85355 10.8536ZM17.1464 13.1464L16.7929 13.5L17.5 14.2071L17.8536 13.8536L17.1464 13.1464ZM13.8536 17.8536L14.2071 17.5L13.5 16.7929L13.1464 17.1464L13.8536 17.8536ZM9 3.5V1.5H8V3.5H9ZM15 20.5V22.5H16V20.5H15ZM3.5 8H1.5V9H3.5V8ZM20.5 16H22.5V15H20.5V16ZM5.35355 4.64645L3.35355 2.64645L2.64645 3.35355L4.64645 5.35355L5.35355 4.64645ZM18.6464 19.3536L20.6464 21.3536L21.3536 20.6464L19.3536 18.6464L18.6464 19.3536ZM2.14645 14.8536L9.14645 21.8536L9.85355 21.1464L2.85355 14.1464L2.14645 14.8536ZM21.8536 9.14645L14.8536 2.14645L14.1464 2.85355L21.1464 9.85355L21.8536 9.14645ZM14.1464 2.14645L10.1464 6.14645L10.8536 6.85355L14.8536 2.85355L14.1464 2.14645ZM6.14645 10.1464L2.14645 14.1464L2.85355 14.8536L6.85355 10.8536L6.14645 10.1464ZM17.8536 13.8536L21.8536 9.85355L21.1464 9.14645L17.1464 13.1464L17.8536 13.8536ZM9.85355 21.8536L13.8536 17.8536L13.1464 17.1464L9.14645 21.1464L9.85355 21.8536Z"
      fill="currentColor" stroke="none" />
  )),
  copy: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M20 7H8V21H20V7Z" stroke="currentColor" fill="none" stroke-linecap="square"/>
      <path d="M16 3H4V17" stroke="currentColor" fill="none" stroke-linecap="square"/>
    </Fragment>
  )),
  adplus: new Icon("0 0 21 23", (
    <path d="M16.25 4.125V7.25H17.25V4.125H20.375V3.125H17.25V0H16.25V3.125H13.125V4.125H16.25ZM8.64429 0.34057L8.64457 0.999783L8.64783 8.49646L12.9943 7.31893L13.625 7.14805V7.80153V20.0314V20.4105L13.26 20.5128L6.24044 22.4814L5.90436 22.5757L5.70005 22.2927L0.719618 15.3946L0.625 15.2636V15.1019V2.96858V2.58951L0.989988 2.48716L8.00956 0.518573L8.64429 0.34057ZM7.64795 8.76735L5.98536 9.21778L5.61511 9.31809L5.61611 9.70168L5.62678 13.8212L5.62846 14.4693L6.25492 14.3032L8.27805 13.7668L8.65008 13.6682L8.64991 13.2833L8.64828 9.53239L12.625 8.45502V19.6523L6.30649 21.4243L1.625 14.9403V3.34765L7.64486 1.65943L7.64795 8.76735ZM7.6484 9.80328L7.64974 12.8989L6.6251 13.1705L6.6171 10.0827L7.6484 9.80328Z"
    fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" stroke="none" />
  )),
  images: new Icon("0 0 20 20", (
    <Fragment>
      <rect x="0.5" y="0.5" width="19" height="19" stroke="currentColor"></rect>
      <path d="M11.0233 8.07147L15.1502 15.5H4.80902L7.08541 10.9472L8.1 12.3L8.58541 12.9472L8.94721 12.2236L11.0233 8.07147Z"
        stroke="currentColor" stroke-linecap="round"></path>
      <circle cx="7" cy="6" r="1.5" stroke="currentColor"></circle>
    </Fragment>
  )),
  professionals: new Icon("0 0 20 20", (
    <Fragment>
      <rect width="20" height="20" fill="none"></rect>
      <path d="M10 19.5H19.4C19.4552 19.5 19.5 19.4552 19.5 19.4V10M10 19.5V15.6281C10 15.563 9.93886 15.5153 9.87575 15.5311L8.12425 15.9689C8.06114 15.9847 8 15.937 8 15.8719V13.6281C8 13.563 8.06114 13.5153 8.12425 13.5311L9.87575 13.9689C9.93886 13.9847 10 13.937 10 13.8719V10M10 19.5H0.6C0.544772 19.5 0.5 19.4552 0.5 19.4V10M10 0.5H6.12808C6.06302 0.5 6.01528 0.561139 6.03106 0.624254L6.46894 2.37575C6.48472 2.43886 6.43698 2.5 6.37192 2.5H4.12808C4.06302 2.5 4.01528 2.43886 4.03106 2.37575L4.46894 0.624254C4.48472 0.561139 4.43698 0.5 4.37192 0.5H0.6C0.544771 0.5 0.5 0.544772 0.5 0.6V10M10 0.5V4.37192C10 4.43698 10.0611 4.48472 10.1243 4.46894L11.8757 4.03106C11.9389 4.01528 12 4.06302 12 4.12808V6.37192C12 6.43698 11.9389 6.48472 11.8757 6.46894L10.1243 6.03106C10.0611 6.01528 10 6.06302 10 6.12808V10M10 0.5H19.4C19.4552 0.5 19.5 0.544772 19.5 0.6V10M0.5 10H4.37192C4.43698 10 4.48472 9.93886 4.46894 9.87575L4.03106 8.12425C4.01528 8.06114 4.06302 8 4.12808 8H6.37192C6.43698 8 6.48472 8.06114 6.46894 8.12425L6.03106 9.87575C6.01528 9.93886 6.06302 10 6.12808 10H10M10 10H13.8719C13.937 10 13.9847 10.0611 13.9689 10.1243L13.5311 11.8757C13.5153 11.9389 13.563 12 13.6281 12H15.8719C15.937 12 15.9847 11.9389 15.9689 11.8757L15.5311 10.1243C15.5153 10.0611 15.563 10 15.6281 10H19.5"
        stroke="currentColor"></path>
    </Fragment>
  )),
  google: new Icon("0 0 24 25", (
    <Fragment>
      <g clip-path="url(#clip0_3229_6811)" fill="none" stroke="none">
        <path d="M23.7643 13.1766C23.7643 12.3609 23.6982 11.5408 23.5571 10.7383H12.2383V15.3593H18.72C18.451 16.8496 17.5868 18.168 16.3213 19.0058V22.0041H20.1883C22.4591 19.9141 23.7643 16.8276 23.7643 13.1766Z" fill="#4285F4"/>
        <path d="M12.2391 24.8997C15.4756 24.8997 18.205 23.8371 20.1936 22.0028L16.3266 19.0045C15.2507 19.7364 13.8618 20.1509 12.2435 20.1509C9.11291 20.1509 6.45849 18.0388 5.50607 15.1992H1.51562V18.2902C3.55274 22.3423 7.70192 24.8997 12.2391 24.8997Z" fill="#34A853"/>
        <path d="M5.50082 15.1972C4.99816 13.7068 4.99816 12.093 5.50082 10.6027V7.51172H1.51478C-0.187219 10.9025 -0.187219 14.8973 1.51478 18.2881L5.50082 15.1972Z" fill="#FBBC04"/>
        <path d="M12.2391 5.6481C13.9499 5.62164 15.6034 6.2654 16.8425 7.44711L20.2685 4.02105C18.0991 1.98394 15.2198 0.863972 12.2391 0.899246C7.70192 0.899246 3.55274 3.45666 1.51562 7.51325L5.50166 10.6042C6.44967 7.76017 9.1085 5.6481 12.2391 5.6481Z" fill="#EA4335"/>
      </g>
      <defs>
        <clipPath id="clip0_3229_6811">
          <rect width="24" height="24" fill="white" transform="translate(0 0.898438)"/>
        </clipPath>
      </defs>
    </Fragment>
  )),
  facebook_blue: new Icon("0 0 24 25", (
    <Fragment>
      <g clip-path="url(#clip0_3229_2707)" fill="none" stroke="none">
        <path d="M24 12.8984C24 6.27102 18.6274 0.898438 12 0.898438C5.37258 0.898438 0 6.27102 0 12.8984C0 18.8879 4.3882 23.8524 10.125 24.7527V16.3672H7.07812V12.8984H10.125V10.2547C10.125 7.24719 11.9166 5.58594 14.6576 5.58594C15.9701 5.58594 17.3438 5.82031 17.3438 5.82031V8.77344H15.8306C14.34 8.77344 13.875 9.69852 13.875 10.6484V12.8984H17.2031L16.6711 16.3672H13.875V24.7527C19.6118 23.8524 24 18.8879 24 12.8984Z" fill="#1877F2"/>
        <path d="M16.6711 16.3672L17.2031 12.8984H13.875V10.6484C13.875 9.69945 14.34 8.77344 15.8306 8.77344H17.3438V5.82031C17.3438 5.82031 15.9705 5.58594 14.6576 5.58594C11.9166 5.58594 10.125 7.24719 10.125 10.2547V12.8984H7.07812V16.3672H10.125V24.7527C11.3674 24.947 12.6326 24.947 13.875 24.7527V16.3672H16.6711Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_3229_2707">
      <rect width="24" height="24" fill="white" transform="translate(0 0.898438)"/>
      </clipPath>
      </defs>
    </Fragment>
  )),
  eye_closed: new Icon("0 0 24 24", (
    <path
      d="M3.5 13.1017C8.43545 18.3493 15.5645 18.3493 20.5 13.1017M3.5 7.43583C5.96774 4.81197 8.98389 3.50002 12 3.5C15.0162 3.49998 18.0323 4.81186 20.5 7.43564M12 17.25V20.5M8.00004 16.75L6.50004 19.2321M15.75 16.75L17.5 19.2321"
      stroke="currentColor"
      fill="none"
      stroke-linecap="square"
    />
  )),
  eye_open: new Icon("0 0 24 24", (
    <path
      d="M2 12L1.54972 11.7827L1.44479 12L1.54972 12.2174L2 12ZM22 11.9999L22.4503 12.2173L22.5552 11.9999L22.4503 11.7825L22 11.9999ZM2.45028 12.2174C4.80463 7.34041 8.44849 5.00003 12 5C15.5515 4.99997 19.1954 7.34029 21.5497 12.2173L22.4503 11.7825C19.9772 6.65957 16.0348 3.99997 12 4C7.96524 4.00003 4.02282 6.65969 1.54972 11.7827L2.45028 12.2174ZM1.54972 12.2174C4.02282 17.3404 7.96524 20 12 19.9999C16.0348 19.9999 19.9772 17.3403 22.4503 12.2173L21.5497 11.7825C19.1954 16.6595 15.5515 18.9999 12 18.9999C8.44848 19 4.80463 16.6596 2.45028 11.7827L1.54972 12.2174ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5V15.5C13.933 15.5 15.5 13.933 15.5 12H14.5ZM12 14.5C10.6193 14.5 9.5 13.3807 9.5 12H8.5C8.5 13.933 10.067 15.5 12 15.5V14.5ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5V8.5C10.067 8.5 8.5 10.067 8.5 12H9.5ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12H15.5C15.5 10.067 13.933 8.5 12 8.5V9.5Z"
      stroke="currentColor"
      fill="none"
    />
  )),
  loader_bouncing_circles: new Icon("0 0 200 200", (
    <Fragment>
      <circle fill="currentColor" stroke="currentColor" stroke-width="6" r="15" cx="40" cy="65">
        <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate>
      </circle>
      <circle fill="currentColor" stroke="currentColor" stroke-width="6" r="15" cx="100" cy="65">
        <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate>
      </circle>
      <circle fill="currentColor" stroke="currentColor" stroke-width="6" r="15" cx="160" cy="65">
        <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate>
      </circle>
    </Fragment>
  )),
  crown: new Icon("0 0 16 16", (
    <Fragment>
      <path d="M13.25 11.9951C13.5098 10.8417 14.2206 8.66484 15 5.24787C10.468 9.08295 8 2.99512 8 2.99512C8 2.99512 5.53196 9.08295 1 5.24787C1.77938 8.66484 2.4484 10.8417 2.7082 11.9951H13.25Z"
        stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 13.9951H13" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </Fragment>
  )),
  square_check: new Icon("0 0 24 24", (
    <path
      d="M20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3V21H3.5V20.5ZM3.5 3.5V3H3V3.5H3.5ZM10.9968 14.25L10.6432 14.6036L10.9968 14.9571L11.3503 14.6036L10.9968 14.25ZM15.8503 10.1036L16.2039 9.75001L15.4968 9.0429L15.1432 9.39646L15.8503 10.1036ZM9.35032 11.8965L8.99676 11.5429L8.28966 12.25L8.64321 12.6036L9.35032 11.8965ZM20 3.5V20.5H21V3.5H20ZM20.5 20H3.5V21H20.5V20ZM4 20.5V3.5H3V20.5H4ZM3.5 4H20.5V3H3.5V4ZM11.3503 14.6036L15.8503 10.1036L15.1432 9.39646L10.6432 13.8965L11.3503 14.6036ZM8.64321 12.6036L10.6432 14.6036L11.3503 13.8965L9.35032 11.8965L8.64321 12.6036Z"
      fill="currentColor" stroke="none"
    />
  )),
  calendar_days: new Icon("0 0 24 24", (
    <path d="M20.5 7.5V3.5H3.5V7.5M20.5 7.5V20.5H3.5V7.5M20.5 7.5H3.5M7.5 11.5H8V12H7.5V11.5ZM16 11.5H16.5V12H16V11.5ZM7.5 16H8V16.5H7.5V16ZM11.75 11.5H12.25V12H11.75V11.5ZM11.75 16H12.25V16.5H11.75V16Z"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  files: new Icon("0 0 24 24", (
    <path d="M17.5 18.5V21.5H4.5V5.5H7.5M15.5 3V7.5H20M7.5 2.5H15.5L20.5 7.5V18.5H7.5V2.5Z"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  envelope: new Icon("0 0 24 24", (
    <path d="M21.5 4.5H22V4H21.5V4.5ZM21.5 19.5V20H22V19.5H21.5ZM2.5 19.5H2V20H2.5V19.5ZM2.5 4.5V4H2V4.5H2.5ZM12 13L11.6834 13.387L12 13.646L12.3166 13.387L12 13ZM21.6111 5.78244L21.998 5.46582L21.3648 4.69186L20.9778 5.00848L21.6111 5.78244ZM3.02218 5.00848L2.6352 4.69186L2.00196 5.46582L2.38894 5.78244L3.02218 5.00848ZM21 4.5V19.5H22V4.5H21ZM21.5 19H2.5V20H21.5V19ZM3 19.5V4.5H2V19.5H3ZM2.5 5H21.5V4H2.5V5ZM20.9778 5.00848L11.6834 12.613L12.3166 13.387L21.6111 5.78244L20.9778 5.00848ZM12.3166 12.613L3.02218 5.00848L2.38894 5.78244L11.6834 13.387L12.3166 12.613Z"
      fill="currentColor" stroke="none"
    />
  )),
  newspaper: new Icon("0 0 24 24", (
    <path d="M16.5 12V3.5H2.5V18C2.5 19.3807 3.61929 20.5 5 20.5H19M16.5 12V18C16.5 19.3807 17.6193 20.5 19 20.5M16.5 12H21.5V18C21.5 19.3807 20.3807 20.5 19 20.5M6 15.5H13M6.5 7.5H12.5V12.5H6.5V7.5Z"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  image_alt: new Icon("0 0 24 24", (
    <path d="M6.5 17.5H11.5M14.5 17.5H17.5M20.5 14.5V3.5H3.5V12V14.5M20.5 14.5V20.5H3.5V14.5M20.5 14.5H15.5H3.5M3.75 11.675L8 7L15.25 14.25M17.5 8C17.5 8.82843 16.8284 9.5 16 9.5C15.1716 9.5 14.5 8.82843 14.5 8C14.5 7.17157 15.1716 6.5 16 6.5C16.8284 6.5 17.5 7.17157 17.5 8Z"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  folder_01: new Icon("0 0 24 24", (
    <path d="M2.5 3.5V19.5H21.5V6.5H12L10 3.5H2.5Z"
      stroke="currentColor" fill="none" stroke-linecap="round"/>
  )),
  globe: new Icon("0 0 24 24", (
    <path d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5M12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5M12 21.5C9.79086 21.5 8 17.2467 8 12C8 6.75329 9.79086 2.5 12 2.5M12 21.5C14.2091 21.5 16 17.2467 16 12C16 6.75329 14.2091 2.5 12 2.5M21 12H3"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  map_pin: new Icon("0 0 24 24", (
    <Fragment>
      <path d="M14.4978 10C14.4978 11.3807 13.3785 12.5 11.9978 12.5C10.6171 12.5 9.4978 11.3807 9.4978 10C9.4978 8.61929 10.6171 7.5 11.9978 7.5C13.3785 7.5 14.4978 8.61929 14.4978 10Z"
        stroke="currentcolor" fill="none" stroke-linecap="square"/>
      <path d="M19.5 10C19.5 16.1919 12 21.5 12 21.5C12 21.5 4.5 16.1919 4.5 10C4.5 5.75 7.85786 2.5 12 2.5C16.1421 2.5 19.5 5.75 19.5 10Z"
        stroke="currentcolor" fill="none" />
    </Fragment>
  )),
  mic: new Icon("0 0 24 24", (
    <path d="M11.9999 19.5C15.4494 19.5 18.3551 17.1712 19.2303 14M11.9999 19.5C8.55038 19.5 5.64478 17.1712 4.76953 14M11.9999 19.5V21.5M11.9999 16.5C9.51463 16.5 7.49992 14.4853 7.49992 12V7C7.49992 4.51472 9.51463 2.5 11.9999 2.5C14.4852 2.5 16.4999 4.51472 16.4999 7V12C16.4999 14.4853 14.4852 16.5 11.9999 16.5Z"
      stroke="currentcolor" fill="none" stroke-linecap="square" />
  )),
  heart_2: new Icon("0 0 24 24", (
    <path d="M12 5.37552C18.5042 -1.25346 29.6544 11.0575 12 21C-5.65441 11.0576 5.4957 -1.25346 12 5.37552Z"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  checkmark: new Icon("0 0 24 24", (
    <path d="M6.5 13.125L9.8 16.5L17.5 7.5"
      stroke="currentColor" fill="none" stroke-linecap="square"/>
  )),
  circle_ban_sign: new Icon("0 0 24 24", (
    <path d="M18.4414 5.5586L5.46929 18.5307M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C9.37665 21.5 7.00165 20.4367 5.28249 18.7175C3.56332 16.9984 2.5 14.6234 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C14.6234 2.5 16.9984 3.56332 18.7175 5.28249C20.4367 7.00165 21.5 9.37665 21.5 12Z"
      stroke="currentColor" stroke-linecap="round" />
  )),
  cross_small: new Icon("0 0 24 24", (
    <path d="M7.5 7.5L16.5 16.5M16.5 7.5L7.5 16.5"
      stroke="currentColor" stroke-linecap="square"/>
  )),
  graduate_cap: new Icon("0 0 24 24", (
    <Fragment>
      <g clip-path="url(#clip0_3105_7669)">
        <path
          d="M4.5001 11.25V17L11.9999 20.5L19.5001 17V11.25M23.5001 9.5V15.25M11.9999 3.5L1.1001 9L11.9999 14.5L22.9001 9L11.9999 3.5Z"
          stroke="currentColor" fill="none" stroke-linecap="square"/>
      </g>
      <defs>
        <clipPath id="clip0_3105_7669">
          <rect width="24" height="24" fill="none"/>
        </clipPath>
      </defs>
    </Fragment>
  )),
  warning: new Icon("0 0 24 24", (
    <path d="M10.5 9.91654V13.6665M10.5 15.7415V15.7499M10.5 4.49988L2.375 18.2499H18.625L10.5 4.49988Z"
      stroke="currentColor" stroke-linecap="square"/>
  )),
};

export default svgs;

